'use client';

import { UserRound } from 'lucide-react';

import type { CommentMessage } from '../../functions';

type ReplyItemProps = {
  reply: CommentMessage;
};

export function ReplyItem({ reply }: ReplyItemProps) {
  if (reply.isDeleted) {
    return (
      <div className="ml-6 mt-3 flex items-start gap-2">
        <div className="bg-raise/20 flex h-7 w-7 shrink-0 items-center justify-center rounded-full">
          <UserRound className="text-content-1 h-4 w-4" />
        </div>
        <p className="text-raise/50 pt-1 text-xs">
          This reply has been deleted.
        </p>
      </div>
    );
  }

  return (
    <div className="ml-6 mt-3 flex items-start gap-2">
      {reply.avatar ? (
        <img
          src={reply.avatar}
          alt={reply.name}
          className="h-7 w-7 shrink-0 rounded-full object-cover"
        />
      ) : (
        <div className="bg-raise/20 flex h-7 w-7 shrink-0 items-center justify-center rounded-full">
          <UserRound className="text-content-1 h-4 w-4" />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <span className="text-content-1 text-sm font-semibold">
          {reply.username ?? reply.name}
        </span>
        <p className="text-content-1 mt-0.5 text-sm">{reply.text}</p>
        {reply.status === 'uploading' && (
          <p className="text-raise/40 mt-0.5 text-[10px]">Sending...</p>
        )}
        {reply.status === 'failed' && (
          <p className="mt-0.5 text-[10px] text-red-400">Failed to send</p>
        )}
      </div>
    </div>
  );
}
